import React, { useState } from 'react'
import "./QuestionView.css";

import HomeIcon from '../images/home';
import ApartmentIcon from '../images/apartment';
import CheckIcon from '../images/CheckIcon';


function QuestionView({Questions, currentQuestion, handleQuestionSelectClick, questionLength, progressBar, educationStatus}) {
    const getAllQuestions = Questions.questions;
    const questionHeadline = Questions.questions[currentQuestion].question;
    const [questionData, setQuestionData] = useState('');
    const [textareaStatus, setTextareaStatus] = useState(false);
    const getImage = (icon) => {
        switch (icon){
            case "home":
                return <HomeIcon/>;
                break;
            case "apartment":
                return <ApartmentIcon/>;
                break;
            default:
                return <HomeIcon/>;
        }
    }

    const handleInputChange = (e) => {
        setQuestionData(e.target.value);
        if(e.target.value.length >= 2){
            setTextareaStatus(true);
        }else{
            setTextareaStatus(false);
        }  
    }
    
    
    return (
        <div className="question-view">
            <div className="question-headline">
                {questionHeadline}
            </div> 
            {currentQuestion >= 1 &&
            <div className="progress-handler">
                <div className="progress-headline">Frage {currentQuestion} von {questionLength}</div>
                <div className="progress">
                    <div className="progress-bar" style={{width: progressBar + '%'}} role="progressbar"></div>
                </div>
            </div>
            }
            <div className="question-answer-handler">
            {getAllQuestions[currentQuestion].answers.map(({title, azubi, icon = null}, index) => (
                title ? 
                    <div key={index} className="question-item" onClick={() => handleQuestionSelectClick(title)}>
                        {icon && <i>
                            {getImage(icon)}
                        </i>}
                        
                            {!educationStatus 
                            ? 
                            <span>{title}</span>
                            : 
                                
                                azubi && <div><span>{azubi}</span></div>
                                
                            }
                            
                            
                        
                    </div>
                :
                    <div key={index} className="question-item-textarea">
                        <textarea 
                            placeholder={"Hier bitte eintragen..."} 
                            onChange={handleInputChange}>
                        </textarea>

                            <span className="textarea-checker" onClick={() => handleQuestionSelectClick(questionData)}>
                                {textareaStatus ? <p>Weiter</p>: <p>Weiter</p>}
                                <i>
                                    <CheckIcon/>
                                </i>
                            </span>
                        
                    </div>
            ))}
            </div>
        </div>
    )
}

export default QuestionView
